import React, {useEffect, useState} from "react";
import ClientProfileCatalogs from "./ClientProfileCatalogs";
import {useCommonStyles} from "../utils/commonStyles";
import CircularProgress from "@material-ui/core/CircularProgress";
import ClientSuscriptionData from "./ClientSuscriptionData";
import ClientProfileConfig from "./ClientProfileConfig";
import {ConfirmProvider} from "material-ui-confirm";

const ClientProfile = (props) => {
    const classes = useCommonStyles();
    const {updateUserData, setState, setNotify} = props;
    const [loading, setLoading] = useState(false);
    useEffect( ()=>{
        var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();

        var s1=document.createElement("script");
        s1.async=true;
        s1.src='https://embed.tawk.to/613135c6d6e7610a49b35e37/1fek3k53a';
        s1.charset='UTF-8';
        s1.setAttribute('crossorigin','*');
        // s0.parentNode.insertBefore(s1,s0);
        document.body.appendChild(s1);
        // return ()=> {
        //     document.body.removeChild(s1);
        // }
    },[]);

    return (
        <div className={classes.layout}>
            {loading && (<div style={{textAlign: "center"}} className={classes.layout}><CircularProgress/></div>)}
            <ConfirmProvider>
                <ClientSuscriptionData
                    setNotify={setNotify}
                    setLoading={setLoading}
                    loading={loading}
                />
            </ConfirmProvider>
            <ClientProfileCatalogs />
            <ClientProfileConfig
                updateUserData={updateUserData}
                setState={setState}
                loading={loading}
                setLoading={setLoading}
            />
        </div>
    )
}
export default ClientProfile;